import {Component, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {catchError, finalize, of, Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {AppState} from "@/store/state";
import {AppService} from "@services/app.service";
import {Router} from "@angular/router";
import Swal from "sweetalert2";
import {shopDetails} from "@pages/modal/shopdetails";
import {MainCategory, MainCategoryClass} from '@pages/modal/mainCategory';
import {SubCategory, SubCategoryClass} from '@pages/modal/subCategory';
import {productDetails, productDetailsData} from '@pages/modal/productdetails';
import {NgxSpinnerService} from "ngx-spinner";
import {ToastrService} from "ngx-toastr";
import {AddProductDataDto, AddProductDto} from "@pages/modal/addProductDto";
import {allShopProductDetails, allShopProductDetailsData} from "@pages/modal/allShopProductDetails";
import {ProductService} from '@services/Product.Service';
import {ShopProductDetails} from "@pages/modal/shopProductDetails/ShopProductDetails";
import {ConfigService} from "@services/configService";

@Component({
    selector: 'product-inclusion',
    templateUrl: './inclusion.component.html',
    styleUrls: ['./inclusion.component.scss'],
})
export class productInclusion implements OnInit, OnDestroy {
    destroy$: Subject<boolean> = new Subject<boolean>();
    images: String = "";
    shopList: shopDetails[] = [];
    subCategoryList: String[] = [];
    categoryList: String[] = [];
    mainCategoryList: MainCategory [] = [];
    subCategory: SubCategory[] = [];
    productName: productDetails[] = [];
    fileList: File[] = [];
    listOfFiles: any[] = [];
    fileUploadStatus: string = "Exist";
    imagePreviews: string[] = [];
    shopType: String[] = [];
    formData = new FormData();
    traderId: number = 0;
    distributorId: number = 0;
    categoryId: number;
    subCategoryId: number;
    newMainCategoryAdd = false;
    newSubCategoryAdd = false;
    createdByShopId: number = 0;
    productId: number = 0;
    shopProductDetails: ShopProductDetails | undefined;
    editorModules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{header: 1}, {header: 2}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{indent: '-1'}, {indent: '+1'}],
            [{size: ['small', false, 'large', 'huge']}],
            [{color: []}, {background: []}],
            [{align: []}],
            ['link', 'image'],
            ['clean']
        ]
    };
    quillInstance: any;
    quantityTypes: string[] = ['Kg', 'Gram', 'Ltr', 'Ml', 'Unit', 'Pack'];

    constructor(private renderer: Renderer2, private store: Store<AppState>,
                private appService: AppService, private router: Router,
                private spinner: NgxSpinnerService, private toaster: ToastrService, private productService: ProductService,
                private configService: ConfigService) {
    }

    productInclusionDetails = new UntypedFormGroup({
        shop: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        shopType: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        brandName: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productName: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        quantityValue: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        quantityType: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        subProductCategory: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        mainProductCategory: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productImage: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        addedBy: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        shopId: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productMRP: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productSRP: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productTax: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        productDiscountType: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        minOrderQty: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        maxOrderQty: new UntypedFormControl("", [Validators.nullValidator, Validators.required]),
        enabled: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopProductMRP: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopProductSRP: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopProductTax: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        sgst: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        gst: new UntypedFormControl('', [
            Validators.required,
            this.gstRangeValidator,
            Validators.min(0),
            Validators.max(18),
        ]),
        cgst: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopProductDiscountType: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopMinOrderQty: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopMaxOrderQty: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        status: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        products: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        distributorId: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        traderId: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        newMainCategory: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        newSubCategory: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        productDesc: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        productShortDescription: new UntypedFormControl('', [Validators.nullValidator, Validators.required]),
        shopProductDescription: new UntypedFormControl('', [Validators.required]),
        subProductCategoryId: new UntypedFormControl(0, [Validators.nullValidator, Validators.required]),
        mainProductCategoryId: new UntypedFormControl(0, [Validators.nullValidator, Validators.required]),
        shopProductId: new UntypedFormControl(0, [Validators.nullValidator, Validators.required]),
    });

    gstRangeValidator(control: AbstractControl): { [key: string]: any } | null {
        const value = parseInt(control.value, 10);
        if (isNaN(value)) return {invalidNumber: true};
        if (value < 0 || value > 18) return {gstOutOfRange: true};
        return null;
    }

    gstZeroValidator(control: AbstractControl): { [key: string]: any } | null {
        const value = parseInt(control.value, 10);
        if (!isNaN(value) && value === 0) {
            return {gstZero: true};
        }
        return null;
    }

    gstCalculation(event: Event): void {
        const input = event.target as HTMLInputElement;
        const gst = Number(input.value);
        if (!isNaN(gst)) {
            const halfGST = gst / 2;
            if (this.productInclusionDetails.get('gst')?.value != 0) {
                this.productInclusionDetails.patchValue({
                    sgst: +halfGST.toFixed(2),
                    cgst: +halfGST.toFixed(2),
                }, {emitEvent: false});
            }
        } else {
            this.productInclusionDetails.patchValue({
                sgst: 0,
                cgst: 0,
            }, {emitEvent: false});
        }
    }

    public productInclusionErrors = {
        shopName: "",
        productName: "",
        brandName: "",
        subCategory: "",
        mainProductCategory: "",
        shopProductMRP: "",
        shopProductSRP: "",
        gst: "",
        productImage: "",
        newMainCategory: "",
        newSubCategory: "",
        quantityType: "",
        quantityValue: "",
        shopProductDescription: "",
        productShortDescription: ""
    }

    onSubmit() {
        this.formValidation();
    }

    onEditorCreated(editor: any) {
        this.quillInstance = editor;

        const html = this.productInclusionDetails.get('shopProductDescription')?.value;
        if (html) {
            this.quillInstance.root.innerHTML = html;
        }
    }

    formValidation() {
        this.productInclusionErrors.shopName = "";
        this.productInclusionErrors.mainProductCategory = "";
        this.productInclusionErrors.subCategory = "";
        this.productInclusionErrors.productName = "";
        this.productInclusionErrors.brandName = "";
        this.productInclusionErrors.quantityValue = "";
        this.productInclusionErrors.quantityType = "";
        this.productInclusionErrors.shopProductMRP = "";
        this.productInclusionErrors.shopProductSRP = "";
        this.productInclusionErrors.productImage = "";
        this.productInclusionErrors.gst = "";
        this.productInclusionErrors.newMainCategory = "";
        this.productInclusionErrors.newSubCategory = "";
        this.productInclusionErrors.shopProductDescription = ""
        this.productInclusionErrors.productShortDescription = ""
        let hasError = false;

        if (this.productInclusionDetails.get("shopId")?.invalid) {
            this.productInclusionErrors.shopName = "Shop Name is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("mainProductCategory")?.invalid) {
            this.productInclusionErrors.mainProductCategory = "Product Category is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("subProductCategory")?.invalid && !this.newMainCategoryAdd) {
            this.productInclusionErrors.subCategory = "Sub Category is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("brandName")?.invalid) {
            this.productInclusionErrors.brandName = "Brand Name is Required";
            hasError = true;
        }

        if (this.productInclusionDetails.get("shopProductDescription")?.invalid) {
            this.productInclusionErrors.shopProductDescription = "Description is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("productName")?.invalid) {
            this.productInclusionErrors.productName = "Product Name is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("quantityValue")?.invalid) {
            this.productInclusionErrors.quantityValue = "Quantity Value is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("quantityType")?.invalid) {
            this.productInclusionErrors.quantityType = "Quantity Type is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("shopProductMRP")?.invalid) {
            this.productInclusionErrors.shopProductMRP = "MRP Price is Required";
            hasError = true;
        }
        if (this.productInclusionDetails.get("shopProductSRP")?.invalid) {
            this.productInclusionErrors.shopProductSRP = "Sale Price is Required";
            hasError = true;
        }
        const gstControl = this.productInclusionDetails.get('gst');
        if (gstControl?.invalid) {
            if (gstControl.errors?.['required']) {
                this.productInclusionErrors.gst = "GST is required";
            } else if (gstControl.errors?.['gstZero']) {
                this.productInclusionErrors.gst = "GST must be greater than 0";
            } else if (gstControl.errors?.['gstOutOfRange']) {
                this.productInclusionErrors.gst = "GST must be between 1 and 18";
            }
            gstControl.markAsTouched();
            hasError = true;
        }
        if (this.newMainCategoryAdd) {
            if (this.productInclusionDetails.get("newMainCategory")?.invalid) {
                this.productInclusionErrors.newMainCategory = "Main Category Name is required";
                hasError = true;
            }
            if (this.productInclusionDetails.get("newSubCategory")?.invalid) {
                this.productInclusionErrors.newSubCategory = "Sub Category Name is required";
                hasError = true;
            }
        }
        if (this.newSubCategoryAdd) {
            if (this.productInclusionDetails.get("newSubCategory")?.invalid) {
                this.productInclusionErrors.newSubCategory = "Sub Category Name is required";
                hasError = true;
            }
        }

        const descControl = this.productInclusionDetails.get('productShortDescription');
        const wordCount = this.getWordCount('productShortDescription');

        if (!descControl?.value || descControl.invalid) {
            this.productInclusionErrors.productShortDescription = "Short Description is Required";
            hasError = true;
        } else if (wordCount < 5) {
            this.productInclusionErrors.productShortDescription = "Minimum 5 words required";
            hasError = true;
        } else if (wordCount > 20) {
            this.productInclusionErrors.productShortDescription = "Maximum 20 words allowed";
            hasError = true;
        }

        if (!hasError) {
            if (this.productId) {
                console.log(`updated Form Group::`, this.productInclusionDetails.value);
                this.updateShopProductById();
            } else {
                this.addProduct();
            }
        }
    }

    getWordCount(controlName: string): number {
        const value = this.productInclusionDetails.get(controlName)?.value || '';
        return value.trim().split(/\s+/).filter(word => word.length > 0).length;
    }

    // Only Integer Enter functionality
    OnlyNumbers($event) {
        let regex: RegExp = new RegExp(/^[0-9]{1,}$/g);
        let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
        if (specialKeys.indexOf($event.key) !== -1) {
            return;
        } else {
            if (regex.test($event.key)) {
                return true;
            } else {
                return false;
            }
        }
    }

    getProduct() {
        var catList: String[] = [];
        this.spinner.show();
        this.appService
            .getCategory()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("Product values::", data);
                this.mainCategoryList = data;
                this.spinner.hide();
                for (let category of this.mainCategoryList) {
                    catList.push(category.catName);
                }
                catList.sort();
                this.categoryList = catList.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                });
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error(error.error.msg || "Something went wrong for get products")
            });
    }

    //Main Category Functionality
    selectCategory(event) {
        const value = event.target.value;
        if (value != "Others") {
            this.newMainCategoryAdd = false;
            this.categoryId = value;
            var catId: Number[] = [];
            for (var id of this.mainCategoryList) {
                if (value == id.catId) {
                    catId.push(id.catId)
                    this.selectSubCategoryDetails(catId)
                }
            }
        } else {
            this.newMainCategoryAdd = true;
        }
    }

    selectSubCategoryDetails(catId: any) {
        var subCategory: String [] = [];
        this.spinner.show();
        this.appService
            .getSubCatID(catId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("subCategory Details ::", data);
                // @ts-ignore
                this.subCategory = data;
                this.spinner.hide();
                for (let subCat of this.subCategory) {
                    subCategory.push(subCat.subCatName);
                }
                subCategory.sort();
                this.subCategoryList = subCategory.filter(function (elem, index, self) {
                    return index === self.indexOf(elem);
                });
            });
    }

    selectSubCategory(event) {
        const value = event.target.value;
        if (value != "Others") {
            this.subCategoryId = value;
            this.newSubCategoryAdd = false;
        } else {
            this.newSubCategoryAdd = true;
        }
    }

    addProduct() {
        Swal.fire({
            title: "Are you Sure to Add The Product In Your Shop?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes,Add Now",
        }).then((result) => {
            if (result.isConfirmed) {
                this.productInclusionDetails.controls['traderId'].setValue(this.traderId);
                this.productInclusionDetails.controls['distributorId'].setValue(this.distributorId);

                let addNewProduct: AddProductDataDto = new AddProductDataDto();

                let shopProduct = new allShopProductDetailsData();
                shopProduct.traderId = Number(this.traderId);
                shopProduct.distributorId = this.distributorId;
                shopProduct.status = "Active";
                shopProduct.shopProductMRP = Number(this.productInclusionDetails.get("shopProductMRP").value);
                shopProduct.shopProductSRP = Number(this.productInclusionDetails.get("shopProductSRP").value);
                shopProduct.mainProductCategoryId = this.categoryId;
                shopProduct.subProductCategoryId = this.subCategoryId;
                shopProduct.appCode = localStorage.getItem('appCode');
                shopProduct.productName = (this.productInclusionDetails.get("productName").value);
                shopProduct.brandName = this.productInclusionDetails.get("brandName").value;
                shopProduct.quantityValue = this.productInclusionDetails.get("quantityValue").value;
                shopProduct.quantityType = this.productInclusionDetails.get("quantityType").value;
                shopProduct.gst = Number(this.productInclusionDetails.get("gst").value)
                shopProduct.cgst = (this.productInclusionDetails.get("cgst").value);
                shopProduct.sgst = (this.productInclusionDetails.get("sgst").value);
                shopProduct.shopProductDescription = this.productInclusionDetails.get("shopProductDescription").value;
                shopProduct.productShortDescription = this.productInclusionDetails.get("productShortDescription").value;


                let product = new productDetailsData();
                product.mainProductCategory = Number(this.productInclusionDetails.get("mainProductCategory").value);
                product.subProductCategory = Number(this.productInclusionDetails.get("subProductCategory").value);
                product.productName = (this.productInclusionDetails.get("productName").value);
                product.brandName = this.productInclusionDetails.get("brandName").value;
                product.quantityValue = this.productInclusionDetails.get("quantityValue").value;
                product.quantityType = this.productInclusionDetails.get("quantityType").value;
                product.addedBy = String(this.traderId);
                product.createdBy = this.createdByShopId;

                if (this.newMainCategoryAdd) {
                    addNewProduct.isNewMainCategoryAdded = true;
                    addNewProduct.isNewSubCategoryAdded = true;
                    let mainCat = new MainCategoryClass();
                    mainCat.catName = this.productInclusionDetails.get("newMainCategory").value
                    mainCat.activeStatus = "Active";
                    mainCat.createdBy = String(this.traderId);

                    let subCat = new SubCategoryClass();
                    subCat.subCatName = this.productInclusionDetails.get("newSubCategory").value
                    subCat.activeStatus = "Active";
                    subCat.createdBy = String(this.traderId);

                    addNewProduct.mainCategory = mainCat;
                    addNewProduct.subCategory = subCat;
                } else if (this.newSubCategoryAdd) {
                    addNewProduct.isNewMainCategoryAdded = false;
                    addNewProduct.isNewSubCategoryAdded = true;
                    let subCat = new SubCategoryClass();
                    subCat.subCatName = this.productInclusionDetails.get("newSubCategory").value
                    subCat.activeStatus = "Active";
                    subCat.createdBy = String(this.traderId);

                    addNewProduct.subCategory = subCat;
                } else {
                    addNewProduct.isNewMainCategoryAdded = false;
                    addNewProduct.isNewSubCategoryAdded = false;
                }

                addNewProduct.shopProduct = shopProduct;
                addNewProduct.products = product;
                console.log(`add product `, addNewProduct);
                this.spinner.show();
                this.appService
                    .saveNewProductInclusion(addNewProduct)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((data) => {
                        this.shopProductDetails = data;
                        if (this.fileList.length > 0) {
                            this.uploadIncludeProductImage(this.shopProductDetails.shopProductId);
                        }
                        this.spinner.hide();
                        this.toaster.success("New Product added successfully")
                        console.log("product Inclusion::", data);
                        this.productInclusionDetails.reset();
                        this.fileList = [];
                    }, (error: any) => {
                        this.spinner.hide();
                        this.toaster.error(error.error.msg || "something went wrong");
                    })
            }
        })
    }

    uploadIncludeProductImage(shopProductId) {
        const formData = new FormData();
        for (const file of this.fileList) {
            formData.append("file", file, file.name)
        }
        this.spinner.show();
        this.appService.productImageUpload(formData, shopProductId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
                this.spinner.hide();
                this.toaster.success("Image uploaded successfully");
                this.fileList = [];
                this.images = "";
                this.imagePreviews = [];
                window.location.reload();
                console.log(`empty::`, this.images);
                this.productInclusionDetails.reset();

            }, (err: any) => {
                this.spinner.hide();
                console.log("Something went wrong, Please try again");
                this.toaster.error(err.error.msg || "Something went wrong, Please try again later")
            })
        this.fileList = [];
    }

    ngOnInit(): void {
        this.getProduct();
        this.productId = this.productService.getProductId();

        if (this.productId) {
            localStorage.setItem('productId', this.productId.toString());
            this.getShopProductById(this.productId);
        } else {
            const storedId = localStorage.getItem('productId');
            if (storedId) {
                this.productId = +storedId;
                this.getShopProductById(this.productId);
            } else {
                // No productId set; prevent unintended behavior
                console.warn('No product ID found in service or localStorage');
            }
        }

        this.getShopDetails();
        console.log('Retrieved productId:', this.productId);
    }

    // Image upload functionality and show in preview card
    onFileSelected(event: any) {
    this.fileList = [];
    this.listOfFiles = [];
    this.imagePreviews = [];

    const allowedTypes = ['image/png', 'image/jpeg'];
    const files = event.target.files;

    for (let i = 0; i < files.length; i++) {
        const selectedFile = files[i];
        const fileType = selectedFile.type;

        if (!allowedTypes.includes(fileType)) {
            this.toaster.error("Only PNG and JPG files are allowed.");
            continue;
        }

        const fileSizeInMb = selectedFile.size / (1024 * 1024);

        if (fileSizeInMb > 2) {
            // Compress image manually
            this.compressImage(selectedFile, fileType, 2 * 1024 * 1024).then((compressedFile: File | null) => {
                if (compressedFile) {
                    this.handleValidFile(compressedFile);
                } else {
                    this.toaster.error("Failed to compress image below 2MB. Try a smaller image.");
                }
            });
        } else {
            // File is already small enough
            this.handleValidFile(selectedFile);
        }
    }
}

handleValidFile(file: File) {
    this.fileList.push(file);
    this.listOfFiles.push(file.name);
    this.fileUploadStatus = "Uploaded";

    const reader = new FileReader();
    reader.onload = (e: any) => {
        this.imagePreviews.push(e.target.result);
    };
    reader.readAsDataURL(file);
}

compressImage(file: File, fileType: string, maxSizeInBytes: number): Promise<File | null> {
    return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e: any) => {
            img.src = e.target.result;
        };

        img.onload = async () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const MAX_WIDTH = 1920;
            const scale = Math.min(1, MAX_WIDTH / img.width);
            const width = img.width * scale;
            const height = img.height * scale;

            canvas.width = width;
            canvas.height = height;

            ctx?.drawImage(img, 0, 0, width, height);

            let quality = 0.9; // start high
            const mimeType = fileType === 'image/png' ? 'image/jpeg' : fileType; // always convert PNG to JPEG for better compression

            const tryCompress = () => {
                return new Promise<Blob | null>((res) => {
                    canvas.toBlob(
                        (blob) => res(blob),
                        mimeType,
                        quality
                    );
                });
            };

            let compressedBlob = await tryCompress();

            // Reduce quality gradually until it's under the size limit or below threshold
            while (compressedBlob && compressedBlob.size > maxSizeInBytes && quality > 0.1) {
                quality -= 0.1;
                compressedBlob = await tryCompress();
            }

            if (compressedBlob && compressedBlob.size <= maxSizeInBytes) {
                const compressedFile = new File([compressedBlob], file.name, { type: mimeType });
                resolve(compressedFile);
            } else {
                resolve(null);
            }
        };

        reader.readAsDataURL(file);
    });
}


    //shop type show functionality
    getShopName(event) {
        const value = event.target.value;
        this.traderId = value;
        this.distributorId = Number(localStorage.getItem("distributorId"));
        this.createdByShopId = this.shopList.find(id => id.traderId == value).shopDetails.shopId;
    }

    getShopDetails() {
        this.appService.getShopDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                    console.log("Shop Details::", data);
                    this.shopList = data;
                    if (this.shopList.length === 1) {
                        const firstShopId = this.shopList[0].traderId;
                        this.productInclusionDetails.get('shopId')?.setValue(firstShopId);
                        this.getShopName({target: {value: firstShopId}}); // Optional: trigger change handler manually
                    }
                },
                (error: any) => {
                    this.spinner.hide();
                    this.toaster.error(error.error.msg || "Something went wrong for get Shop Details")
                })
    }


    getShopProductById(shopProductId: number): void {
        if (!shopProductId) {
            console.warn('Invalid shopProductId');
            return;
        }

        this.spinner.show();

        this.appService.getShopProductByShopProductId(shopProductId)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => this.spinner.hide()),
                catchError((error: any) => {
                    console.error('Error fetching shop product:', error);
                    this.toaster.error('Failed to load product details. Please try again later.', 'Error');
                    return of(null); // Return a safe observable to prevent breaking the stream
                })
            )
            .subscribe((shopProduct) => {
                if (shopProduct) {
                    this.shopProductDetails = shopProduct;
                    console.log(`shop product ID::`, this.shopProductDetails);
                    this.getShopDetails();
                    this.updateFormData(this.shopProductDetails);
                } else {
                    this.toaster.warning('Product not found', 'Warning');
                }
            });
    }


    updateFormData(shopProduct: ShopProductDetails) {

        setTimeout(() => {
            this.productInclusionDetails.patchValue({
                shopProductDescription: shopProduct.shopProductDescription,
                shopProductId: shopProduct.shopProductId ?? this.productId,
                brandName: shopProduct.brandName || '',
                quantityValue: shopProduct.quantityValue || '',
                quantityType: shopProduct.quantityType || '',
                productName: shopProduct.productName ?? shopProduct.products?.productName,
                subProductCategory: Number(shopProduct.subProductCategoryId),
                subProductCategoryId: shopProduct.subProductCategoryId,
                mainProductCategoryId: shopProduct.mainProductCategoryId,
                mainProductCategory: shopProduct.mainProductCategoryId,
                productImage: shopProduct.productImage,
                addedBy: shopProduct.products?.addedBy,
                shopId: shopProduct.trader_name,
                productMRP: shopProduct.shopProductMRP,
                productSRP: shopProduct.shopProductSRP,
                productTax: (shopProduct.cgst || 0) + (shopProduct.sgst || 0),
                productDiscountType: shopProduct.shopProductDiscountType,
                minOrderQty: shopProduct.products?.minOrderQty || 0,
                maxOrderQty: shopProduct.products?.maxOrderQty || 0,
                enabled: shopProduct.enabled,
                shopProductMRP: shopProduct.shopProductMRP,
                shopProductSRP: shopProduct.shopProductSRP,
                shopProductTax: (shopProduct.cgst || 0) + (shopProduct.sgst || 0),
                sgst: shopProduct.sgst,
                cgst: shopProduct.cgst,
                shopProductDiscountType: shopProduct.shopProductDiscountType,
                shopMinOrderQty: shopProduct.shopMinOrderQty,
                shopMaxOrderQty: shopProduct.shopMaxOrderQty,
                status: shopProduct.status,
                products: shopProduct.products,
                distributorId: shopProduct.distributorId,
                traderId: shopProduct.traderId,
                productDesc: shopProduct.shopProductDescription ?? shopProduct.products.productDesc,
                productShortDescription: shopProduct.productShortDescription,
                gst: shopProduct.gst
            });

            if (this.quillInstance) {
                this.quillInstance.root.innerHTML = shopProduct.shopProductDescription || '';
            }

            this.productInclusionDetails.controls['shopId'].setValue(shopProduct.traderId);
            this.selectSubCategoryDetails(shopProduct.mainProductCategoryId);
            this.productInclusionDetails.controls['subProductCategoryId'].setValue(shopProduct.subProductCategoryId || this.productInclusionDetails.get('subProductCategory').value);
            this.productInclusionDetails.controls['mainProductCategoryId'].setValue(shopProduct.mainProductCategoryId || this.productInclusionDetails.get('mainProductCategory').value);

            // Debug: check if value is in form control
            console.log('Quill description value after patch:', this.productInclusionDetails.get('shopProductDescription')?.value);
        }, 0);
    }

    getImage(): string {
        if (this.shopProductDetails.productImage != null && this.shopProductDetails.productImage != "") {
            return this.configService.getConfig().END_POINT + `/api/store/getProductImage/${this.shopProductDetails.shopProductId}`
        } else {
            return this.configService.getConfig().END_POINT + `/api/getProductImage/${this.shopProductDetails.products?.productId}`
        }
    }


    updateShopProductById() {
        this.productInclusionDetails.removeControl('subProductCategory');
        this.productInclusionDetails.removeControl('mainProductCategory');
        console.log(`updated form group::`, this.productInclusionDetails.value)
        this.spinner.show();
        this.appService.updateShopProductByShopProductId(this.productInclusionDetails.value)
            .pipe(takeUntil(this.destroy$),
                finalize(() => this.spinner.hide())
            )
            .subscribe({
                next: (shopProductDetails) => {
                    console.log(`update details::`, shopProductDetails);
                    this.shopProductDetails = shopProductDetails;
                    console.log(`updated response::`, this.shopProductDetails);
                    if (this.imagePreviews.length > 0) {
                        this.uploadIncludeProductImage(this.shopProductDetails.shopProductId);
                        this.toaster.success(`Your product updated successfully`);
                    } else {
                        this.toaster.success(`Your product updated successfully`);
                        this.productInclusionDetails.reset();
                        this.imagePreviews = [];
                        this.images = ""
                        this.productId = 0;
                        /*window.location.reload();*/
                    }
                },
                error: (error) => {
                    console.error("Error:", error);
                    this.spinner.hide();
                    const errorMessage = error?.error?.msg ?? "Something went wrong, please try again.";
                    this.toaster.error(errorMessage);
                }
            });
    }


    checkCategoryExistList(event: any) {
        const inputValue = event.target.value.trim().toLowerCase();
        const isExist = this.mainCategoryList
            .map(i => i.catName.trim().toLowerCase())
            .includes(inputValue);

        const control = this.productInclusionDetails.get('newMainCategory');

        if (isExist) {
            /*this.showErrorMessage('Main Category Name Already exists');*/
            control?.setErrors({categoryExists: true});
        } else {
            // Clear this specific error if the name is now unique
            if (control?.hasError('categoryExists')) {
                const currentErrors = control.errors;
                if (currentErrors) {
                    delete currentErrors['categoryExists'];
                    if (Object.keys(currentErrors).length === 0) {
                        control.setErrors(null);
                    } else {
                        control.setErrors(currentErrors);
                    }
                }
            }
        }
    }

    checkSubCategoryExistList(event: any) {
        const inputValue = event.target.value.trim().toLowerCase();
        console.log(inputValue)
        const isExist = this.subCategory.filter(sub => sub.mainProductCategory?.catId == this.categoryId)
            .map(i => i.subCatName.trim().toLowerCase())
            .includes(inputValue);

        console.log(isExist)

        const control = this.productInclusionDetails.get('newSubCategory');

        if (isExist) {
            control?.setErrors({subCategoryExists: true});
        } else {
            // Clear this specific error if the name is now unique
            if (control?.hasError('subCategoryExists')) {
                const currentErrors = control.errors;
                if (currentErrors) {
                    delete currentErrors['subCategoryExists'];
                    if (Object.keys(currentErrors).length === 0) {
                        control.setErrors(null);
                    } else {
                        control.setErrors(currentErrors);
                    }
                }
            }
        }
    }

    ngOnDestroy(): void {
        this.productService.clearProductId();
        localStorage.removeItem('productId');
    }

}
